module.exports = __webpack_public_path__ + "img/blueRoundaccess.5df8238d.svg";